document.addEventListener('scroll', function () {
    const stickyIcons = document.querySelector('.js-sticky-icons');
    const pageHeader = document.querySelector('.page-header');
    const links = document.querySelectorAll('.js-sticky-icons a');
	const initialPosition = stickyIcons.parentNode.offsetTop;

    if (stickyIcons && initialPosition - 200 <= window.scrollY ) {
        pageHeader.classList.remove('sticky');
        if (stickyIcons) {
			stickyIcons.classList.add('sticky');
        }
    } else {
		stickyIcons.classList.remove('sticky');
	}

    links.forEach(link => {
        const targetId = link.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
            const targetTop = targetElement.offsetTop;
            const targetHeight = targetElement.offsetHeight;
            const scrollY = window.scrollY;

            if (scrollY >= targetTop - 100 && scrollY < targetTop + targetHeight) {
                links.forEach(l => l.classList.remove('active'));
                link.classList.add('active');
            } else if (scrollY < document.querySelector('.js-sticky-icons').offsetTop) {
				link.classList.remove('active');
			}
        }
    });
});

